<template>
  <div>
    <top-bar heading="RTOs" :buttons="buttons"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <b-card>
        <b-table responsive="md" striped hover :items="rtos" :fields="['id', 'name', 'updated_at', 'actions']">

          <template  v-slot:cell(updated_at)="data">
            {{ data.item.updated_at | moment('calendar') }}
          </template>

          <template  v-slot:cell(actions)="data">
            <router-link :to="'/tools/rtos/' + data.item.id" class="btn btn-primary btn-sm">Edit</router-link>
          </template>

        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RTOs',
  data () {
    return {
      rtos: [],
      loaded: false,
      buttons: [
        {
          label: 'Add RTO',
          click: this.addRto
        }
      ]
    };
  },
  methods: {
    getRtos () {
      this.loaded = false;
      this.axios.get('/rtos').then(rsp => {
        this.rtos = rsp.data.data.map(rto => {
          rto.actions = '';

          return rto;
        });
        this.loaded = true;
      });
    },
    addRto () {
      this.axios.post('/rtos').then(() => {
        this.getRtos();
      });
    }
  },
  mounted () {
    this.getRtos();
  },
  metaInfo: {
    title: 'RTOs'
  }
};
</script>
